let produs_id_arr = [];
const addAllProductsToCart = function () {
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  async function addToCart(variantId, quantity) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: parseInt(quantity, 10),
        }),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to add product with ID ${variantId} to the cart: ${response.statusText}`
        );
      }

      const responseData = await response.json();
      console.log(
        `Successfully added product with ID ${variantId} to the cart.`
      );
      return responseData;
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const addAllToCartButtons = document.querySelectorAll(
    ".stl-column .add-all-to-cart"
  );
  addAllToCartButtons.forEach(function (button) {
    button.addEventListener("click", async function (event) {
      event.preventDefault();

      const buttonWrapper = event.target.closest(".buttons-wrapper");
      const forms = buttonWrapper.querySelectorAll(".add-all-form");
      const messageDiv = buttonWrapper.querySelector(".add-to-cart-message");

      messageDiv.textContent = "Produsele se adaugă în coș...";
      messageDiv.style.transition = "transform 0.3s ease";
      messageDiv.style.transform = "scale(1)";
      messageDiv.style.transition = "opacity 0.5s ease";
      messageDiv.style.opacity = "1";

      for (let i = 0; i < forms.length; i++) {
        const formData = new FormData(forms[i]);
        const variantId = formData.get("id");
        const quantity = formData.get("quantity");
        if (variantId) {
          if (!produs_id_arr.includes(variantId)) {
            produs_id_arr.push(variantId);
            console.log(produs_id_arr);
            await addToCart(variantId, quantity);
          }
          await delay(500);
        }
        // if (variantId) {
        //   console.log("Test");
        //   await addToCart(variantId, quantity);
        //   await delay(500);
        // }
      }

      messageDiv.textContent = "";
      messageDiv.style.opacity = "0";
      messageDiv.style.transform = "scale(0.5)";
      window.location.href = "/cart";
    });
  });
};
addAllProductsToCart();
